define('core/biblio',["exports", "core/render-biblio", "core/biblio-db", "core/utils", "core/pubsubhub"], function (exports, _renderBiblio, _biblioDb, _utils, _pubsubhub) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.done = exports.name = exports.stringifyReference = exports.wireReference = undefined;
  Object.defineProperty(exports, "wireReference", {
    enumerable: true,
    get: function () {
      return _renderBiblio.wireReference;
    }
  });
  Object.defineProperty(exports, "stringifyReference", {
    enumerable: true,
    get: function () {
      return _renderBiblio.stringifyReference;
    }
  });
  exports.updateFromNetwork = updateFromNetwork;
  exports.resolveRef = resolveRef;
  exports.run = run;
  const name = exports.name = "core/biblio";

  const bibrefsURL = new URL("https://specref.herokuapp.com/bibrefs?refs=");

  // Normative references take precedence over informative ones,
  // so any duplicates ones are removed from the informative set.
  function normalizeReferences(conf) {
    Array.from(conf.informativeReferences).filter(key => conf.normativeReferences.has(key)).forEach(redundantKey => conf.informativeReferences.delete(redundantKey));
  }

  function getRefKeys(conf) {
    return {
      informativeReferences: Array.from(conf.informativeReferences),
      normativeReferences: Array.from(conf.normativeReferences)
    };
  }

  // Opportunistically dns-prefetch to bibref server, as we don't know yet
  // if we will actually need to download references yet.
  const link = (0, _utils.createResourceHint)({
    hint: "dns-prefetch",
    href: bibrefsURL.origin
  });
  document.head.appendChild(link);
  let doneResolver;
  const done = exports.done = new Promise(resolve => {
    doneResolver = resolve;
  });

  async function updateFromNetwork(refs, options = { forceUpdate: false }) {
    const refsToFetch = [...new Set(refs)].filter(ref => ref.trim());
    // Update database if needed, if we are online
    if (!refsToFetch.length || navigator.onLine === false) {
      return;
    }
    let response;
    try {
      response = await fetch(bibrefsURL.href + refsToFetch.join(","));
    } catch (err) {
      console.error(err);
      return null;
    }
    if (!options.forceUpdate && !response.ok || response.status !== 200) {
      return null;
    }
    const data = await response.json();
    try {
      await _biblioDb.biblioDB.addAll(data);
    } catch (err) {
      console.error(err);
    }
    return data;
  }

  async function resolveRef(key) {
    const biblio = await done;
    if (!biblio.hasOwnProperty(key)) {
      return null;
    }
    const entry = biblio[key];
    if (entry.aliasOf) {
      return await resolveRef(entry.aliasOf);
    }
    return entry;
  }

  async function run(conf, doc, cb) {
    const finish = () => {
      doneResolver(conf.biblio);
      cb();
    };
    if (!conf.localBiblio) {
      conf.localBiblio = {};
    }
    if (conf.biblio) {
      let msg = "Overriding `.biblio` in config. Please use ";
      msg += "`.localBiblio` for custom biblio entries.";
      (0, _pubsubhub.pub)("warn", msg);
    }
    conf.biblio = {};
    const localAliases = Array.from(Object.keys(conf.localBiblio)).filter(key => conf.localBiblio[key].hasOwnProperty("aliasOf")).map(key => conf.localBiblio[key].aliasOf);
    normalizeReferences(conf);
    const allRefs = getRefKeys(conf);
    const neededRefs = allRefs.normativeReferences.concat(allRefs.informativeReferences)
    // Filter, as to not go to network for local refs
    .filter(key => !conf.localBiblio.hasOwnProperty(key))
    // but include local aliases, in case they refer to external specs
    .concat(localAliases)
    // remove duplicates
    .reduce((collector, item) => {
      if (collector.indexOf(item) === -1) {
        collector.push(item);
      }
      return collector;
    }, []).sort();
    const idbRefs = [];

    // See if we have them in IDB
    try {
      await _biblioDb.biblioDB.ready; // can throw
      const promisesToFind = neededRefs.map(async id => ({
        id,
        data: await _biblioDb.biblioDB.find(id)
      }));
      idbRefs.push(...(await Promise.all(promisesToFind)));
    } catch (err) {
      // IndexedDB died, so we need to go to the network for all
      // references
      idbRefs.push(...neededRefs.map(id => ({ id, data: null })));
      console.warn(err);
    }
    const split = { hasData: [], noData: [] };
    idbRefs.reduce((collector, ref) => {
      ref.data ? collector.hasData.push(ref) : collector.noData.push(ref);
      return collector;
    }, split);
    split.hasData.reduce((collector, ref) => {
      collector[ref.id] = ref.data;
      return collector;
    }, conf.biblio);
    const externalRefs = split.noData.map(item => item.id);
    if (externalRefs.length) {
      // Going to the network for refs we don't have
      const data = await updateFromNetwork(externalRefs, { forceUpdate: true });
      Object.assign(conf.biblio, data);
    }
    Object.assign(conf.biblio, conf.localBiblio);
    await updateFromNetwork(neededRefs);
    finish();
  }
});
//# sourceMappingURL=biblio.js.map;
